import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { cleanObject } from '../utils/formatters';
export const socialScreenshotsDefaults = {
  img1200x630: null
};
export default class SocialScreenshots extends createImmutableObjectClass(socialScreenshotsDefaults, {
  fromJSON: (_ref) => {
    let rest = Object.assign({}, _ref);
    return cleanObject(Object.assign({}, rest));
  },
  toJSON: (_ref2) => {
    let rest = Object.assign({}, _ref2);
    return Object.assign({}, rest);
  }
}) {}